import gql from 'graphql-tag';

const CAMPAIGN_ORDER_BASKET_ITEMS = gql`
  query campaignOrderBasketItems(
    $where: CampaignOrderTransactionsBasketItemsWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionsBasketItemsOrderByInput
  ) {
    campaignOrderTransactionsBasketItemsesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          quantity
          price
          total
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionsBasketItemsesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_BASKET_ITEMS;
